import React from "react";
import { Paper, Box, Typography, Divider } from "@mui/material";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import SignupForm from "./SignUpForm";
import SignupAlert from "./SignUpAlert";
import useSignupForm from "../hooks/useSignUpForm";

const Signup = () => {
  const {
    formData,
    error,
    success,
    loading,
    handleChange,
    handleSubmit,
    clearSuccess,
  } = useSignupForm();

  return (
    <Paper
      elevation={0}
      sx={{
        width: "100%",
        maxWidth: { xs: "100%", sm: 700 },
        mx: "auto",
        mt: { xs: 1, sm: 1.5 },
        mb: 0,
        p: { xs: 1.5, sm: 2 },
        borderRadius: { xs: 2, sm: 4 },
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        minWidth: 0,
        overflow: "hidden",
        background:
          "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)",
        backdropFilter: "blur(12px)",
        border: "1px solid rgba(255, 255, 255, 0.15)",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        color: "white",
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mb: 1.5,
          }}
        >
          <PersonAddAlt1Icon
            sx={{ mr: 1, fontSize: 20, color: "rgba(255,255,255,0.8)" }}
          />
          <Typography fontWeight={600} fontSize={16} letterSpacing={0.4}>
            Create New User
          </Typography>
        </Box>

        <Divider sx={{ mb: 2, borderColor: "rgba(255,255,255,0.1)" }} />

        <SignupForm
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      </Box>

      <Box sx={{ mt: "auto", pt: 1.5 }}>
        <SignupAlert
          error={error}
          success={success}
          onSuccessClose={clearSuccess}
        />
      </Box>
    </Paper>
  );
};

export default Signup;
